export const DashboardConstant = {
  DEFAULTERR: 'sorry unable to process! please try again later',

  GETCAMPAIGNSTOTALCOUNTSSUCCESS: 'GET_CAMPAIGNS_TOTAL_COUNTS_SUCCESS',
  GETCAMPAIGNSTOTALCOUNTSFAIL: 'GET_CAMPAIGNS_TOTAL_COUNTS_FAIL',

  GETLINECHARTDATASUCCESS: 'GET_LINE_CHART_DATA_SUCCESS',
  GETLINECHARTDATAFAIL: 'GET_LINE_CHART_DATA_FAIL',
};
